import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import keycloak from './keycloak';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Enquanto o Keycloak inicializa (e, se preciso, redireciona pra tela de
// login), mostra um loading no lugar da tela em branco.
root.render(
  <Backdrop sx={{ color: '#fff', zIndex: 9999 }} open>
    <CircularProgress color="inherit" />
  </Backdrop>
);

keycloak
  .init({
    onLoad: 'login-required', // exige login antes de mostrar qualquer tela
    pkceMethod: 'S256',
    checkLoginIframe: false,
  })
  .then((authenticated) => {
    if (!authenticated) {
      // onLoad: 'login-required' já deveria ter redirecionado ao Keycloak;
      // se chegou aqui sem autenticar, tenta de novo.
      window.location.reload();
      return;
    }

    // Mantém o token sempre válido enquanto o usuário estiver usando o
    // sistema, renovando um pouco antes de expirar.
    setInterval(() => {
      keycloak.updateToken(30).catch(() => {
        console.warn('Não foi possível renovar o token, efetuando logout.');
        keycloak.logout();
      });
    }, 20000);

    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  })
  .catch((err) => {
    console.error('Falha ao inicializar autenticação via Keycloak', err);
    root.render(
      <div style={{ padding: 32, fontFamily: 'sans-serif' }}>
        Não foi possível conectar ao serviço de autenticação (Keycloak).
        Verifique se ele está rodando e tente novamente.
      </div>
    );
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
